import { ApolloError } from 'apollo-client'
import { isLoadFailure } from '../util/graphqlErrors'

// What a record page or edit page shows for its record lookup, decided in one place so the
// pages can't drift apart (CVL-145):
// - 'loading'  the lookup hasn't answered yet;
// - 'failed'   the connection or the server failed, so the record may well exist
//              ("Something went wrong. Please try again."), even when part of the page has it;
// - 'found'    the record is there;
// - 'notFound' the address matches nothing the visitor may see ("We couldn't find that ...").
export type RecordLookup = 'loading' | 'found' | 'failed' | 'notFound'

const useRecordLookup = ({ loading, error, record }: { loading: boolean; error?: ApolloError; record: unknown }): RecordLookup => {
  if (loading) return 'loading'
  if (isLoadFailure(error)) return 'failed'
  return record ? 'found' : 'notFound'
}

export default useRecordLookup
